import React from "react";
import { NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import logo from '../logo.svg';

const Header = () => {

 


  return (


<nav className="navbar">

        <NavLink to="/"  aria-current="page" >
            <i className="fas fa-home"></i>
              <span>home</span>
         </NavLink>

         <NavLink to="/about"  aria-current="page" >
            <i className="fas fa-user"></i>
              <span>Sobre mim </span>
         </NavLink>

         <NavLink to="/porta" aria-current="page" >
           <i className="fas fa-briefcase"></i>
            <span>Experiências</span>
        </NavLink>
   

        <NavLink to="/blog" aria-current="page" >
        <i className="fas fa-grin-alt"></i> 
           <span>Interesses</span>
        </NavLink>
   
        <NavLink to="/contacto" aria-current="page" >
            <i className="fas fa-phone"></i>
              <span>contato</span>
        </NavLink>
   
  

    

    
</nav>

    
/*
<navclassName="navbar navbar-expand-lg navbar navbar-dark bg-dark">
  <div className="container-fluid">

        <a className="navbar-brand" href="#">
          <img src={logo} alt="logo" className="App-logo d-inline-block align-text-top" alt="logo" />
          DiegoSoft
        </a>

      

  
 
    <div className="collapse navbar-collapse" id="navbarNavDropdown">
      <ul className="navbar-nav">
        <li className="nav-item">
          
          <NavLink to="/" className="btn nav-link active" aria-current="page" >
          Home
         </NavLink>
        </li>
        <liclassName="nav-item">
        <NavLink to="/agregar" className="btn  nav-link active " aria-current="page" >
          Agregar
        </NavLink>
        </li>
        <liclassName="nav-item">
        <NavLink to="/about" className="btn  nav-link active" aria-current="page" >
         Acerca de DiegoSoft
        </NavLink>
        </li>
    
      </ul>
    </div>
  </div>
</nav>
 */   



  )


};

export default Header;
